<script>
    import { fade } from 'svelte/transition';
    import {link , push} from 'svelte-spa-router'
    import fetchData from '../api.js';
    import UserStore from '../stores/user';
    import { validateFields }  from '../base/validation.js';
    import { _ } from "svelte-i18n";
    import { onMount } from 'svelte';
    import Header from '../components/Header.svelte'; 
    import TopInfo from '../components/TopInfo.svelte';  
    import Preloader from '../components/Preloader.svelte'; 
    import ToolTip from '../components/ToolTip.svelte'; 

    let isLoading = false;

    let methodTemp = {
        shipping_push_supplier_code  : '',
        shipping_push_supplier_code_pickup  : '',
        enable_pickup : "0",
        shipping_pickup_price  : '',
        shipping_free_pickup_above  : '',
        limit_results  : '',
        shipping_push_supplier : '',
        shipping_pull_platform : '', 
        pickup_static_text : "",           
        shipping_push_supplier_token : "",    
        auto_pickup : "0",
        auto_pickup_text : "",
        shipping_push_supplier_username1 : "",
        shipping_push_supplier_username2 : "",
        shipping_push_supplier_username3 : "",
        shipping_push_supplier_password : ""
    }

    let erp_settings = {};
    let settings = {
        shipping_method : [],
    }

    // onMount(async() => {

    //     await fetchPage(); 
       
    // })    


    const fetchPage = async() => {


        if (!$UserStore || !$UserStore.data){
            push('/login');
            return;
        } 

        let temp_settings = {}

        let tempCompareMethods = $UserStore?.settings?.shipping_settings?.shipping_method ?? [];


        if (!tempCompareMethods.length && shipping_push_supplier!='') {

            let newMethodTemp = {...methodTemp}   
            newMethodTemp.shipping_push_supplier = shipping_push_supplier  

            $UserStore.settings.shipping_settings.shipping_method = [
                newMethodTemp
            ];


        }



        if ($UserStore.settings && $UserStore.settings.shipping_settings && $UserStore.settings.shipping_settings.shipping_method) {

            for(var key in $UserStore.settings.shipping_settings) {

                settings[key] = $UserStore.settings.shipping_settings[key];

                if (key=='shipping_method') {  
                    
                    if (!Array.isArray(settings[key])) {
                        settings[key] = []

                    } else {     
                        
                        let newMethodTemp = {...methodTemp}                    

                        for(var key2 in settings[key]) {
                            for(var key3 in newMethodTemp) {


                                if (typeof settings[key][key2][key3]==='undefined' && typeof newMethodTemp[key3]!=='undefined') {

                                     settings[key][key2][key3] = newMethodTemp[key3];
                                }



                            } 

                        }

                    }

                    

                }

            }

            settings = {...settings};

            console.log(settings.shipping_method)

        }

    }


    fetchPage(); 



    const handleSubmit = async() => {


        if (!validateFields(settings,2)) {
            
            alert('יש מלא את כל השדות חובה')
            return;
        }

        isLoading = true;

        let postData = {};

        postData.action = 'w_update_shipping_methods';
        postData.token = $UserStore.data
        postData.datalogics_shipping_method = settings.shipping_method;

        let response = await fetchData(postData);
        if (response.data) {

            $UserStore.settings = response.data;
            localStorage.setItem('user',JSON.stringify($UserStore))            

            alert('הנתונים נשמרו בהצלחה')

        }



        isLoading = false;


    }

    function validateAndSetSupplierCode(platform_id,value) {

        let inputValue = value;   	

        if (platform_id==62 || platform_id=="62") {

            // Remove non-digits and non-letters
            inputValue = inputValue.replace(/[^0-9a-zA-Z]/g, '');

            // Limit to 4 characters
            inputValue = inputValue.substring(0, 4);


            // Ensure the first two characters are digits
            if (inputValue.length >= 2 && !/^\d{2}/.test(inputValue)) {
                // If the first two characters are not digits, remove them
                inputValue = inputValue.substring(2);
            }  
            
            

        }

        //settings.shipping_push_supplier_code = inputValue.trim();


        return inputValue;

    }
    

    let selectedPlatform = '';


    function addCompany() {
        
        let pass = true;
        for(var key in settings.shipping_method) {

            if (settings.shipping_method[key].shipping_push_supplier==selectedPlatform) {
                pass = false;
            }

        }

        if (pass == true) {
            let newMethodTemp = {...methodTemp}
            newMethodTemp.shipping_push_supplier = selectedPlatform;
            settings.shipping_method.push(newMethodTemp);
            settings = {...settings}
        }
    }

    function removeCompany(index) {

        if (confirm(`${$_('companies.delete_confirmation')}`)) {

            settings.shipping_method.splice(index, 1);

            settings = {...settings}

        }
        
    }
    
</script>

<div class="page-container" transition:fade={{ delay: 250, duration: 300 }}>
    <Preloader {isLoading}/>
    <Header />
    <div class="page">    
        <TopInfo/>
        <div class="shipment">            
            <h1 class="text-[20px] font-bold text-start">
                {#if shippingo=="1" || shippingo=="2"}
                {$_('companies.title')}
                {:else}
                {$_('header.account')}
                {/if}
            </h1>        
            <div class="shipment-flex">
                <div class="shipment_origin">
                    {#if (shippingo=="2" || shippingo=="1") && Object.keys(platforms).length}                    
                    <div class="">
                        <label>{$_('companies.select_shipping_company')}</label>
                        <div class="input_box flex">
                            <div class="input_con w-[300px] flex-none">                                
                                <select bind:value={selectedPlatform}>
                                    <option value="">{$_('companies.choose_company')}</option>
                                    {#each Object.entries(platforms) as [platform_id, platform]}
                                        
                                        <option value="{platform_id}">{platform.name}</option>
                                        
                                    {/each}
                                </select>                                
                            </div> 
                            <div class="create_button w-[100px] flex-none" on:click={ addCompany }>{$_('companies.add')}</div>
                        </div>
                        <div class="mb-5">
                            {#if shippingo=="1"}
                            {$_('companies.shipping_company_not_exist_msg_shippingo')}
                            {:else if shippingo=="2"}
                            {$_('companies.shipping_company_not_exist_msg')}
                            {/if}
                        </div>                        
                    </div>
                    {/if}                    
                    {#each settings.shipping_method as method,index}                        
                        {#if platforms[+method.shipping_push_supplier]}
                        <div
                            class="platform_box relative"
                            class:bg-slate-50={shippingo == '1' || shippingo == '2'}
                            class:hover:bg-slate-100={shippingo === '1' || shippingo == '2'}
                            class:border-[1px]={shippingo == '1' || shippingo == '2'}
                            class:border-slate-300={shippingo == '1' || shippingo == '2'}
                            class:p-4={shippingo === '1' || shippingo == '2'}
                            class:rounded-[5px]={shippingo == '1' || shippingo == '2'}
                            class:mb-5={shippingo == '1' || shippingo == '2'}
                            >
                            {#if shippingo=="1" || shippingo == "2"}
                            <div class="flex justify-end w-auto">
                                <div on:click={()=> { removeCompany(index) } } class="pointer border-1 bg-slate-700 rounded-[5px] px-4 py-2 text-white text-center">{$_('companies.delete')}</div>
                            </div>
                            <div class="input_box">
                                <h3 class="text-[16px] font-bold">{platforms[+method.shipping_push_supplier].name}</h3>                                
                            </div>
                            {/if}
                            {#if erp_settings.platform2}
                            <div class="input_box">
                                <div class="input_con">
                                    <label><i class="fa-solid fa-asterisk"></i>{$_('settings.username')}</label>
                                    <input type="text" bind:value={erp_settings.platform2_username} class:input_empty_error={erp_settings.platform2_username === ''}>
                                </div>      
                                <div class="input_con">
                                    <label><i class="fa-solid fa-asterisk"></i> {$_('settings.password')}</label>
                                    <input type="text" bind:value={erp_settings.platform2_password} class:input_empty_error={erp_settings.platform2_password === ''}>
                                </div>
                            </div>
                            {/if}

                            {#if method.shipping_push_supplier==72}

                            <div class="input_box">
                                <div class="input_con">
                                    <label><i class="fa-solid fa-asterisk"></i> {$_('settings.username')}</label>
                                    <input type="text" bind:value={method.shipping_push_supplier_username} class:input_empty_error={method.shipping_push_supplier_username === ''}>
                                </div>      
                                <div class="input_con">
                                    <label><i class="fa-solid fa-asterisk"></i> {$_('settings.password')}</label>
                                    <input type="text" bind:value={method.shipping_push_supplier_password} class:input_empty_error={method.shipping_push_supplier_password === ''}>
                                </div>
                            </div>

                            {:else if method.shipping_push_supplier==76}

                            <div class="input_box">
                                <div class="input_con">
                                    <label>
                                        <i class="fa-solid fa-asterisk"></i> 
                                        {$_('settings.username')}
                                    </label>
                                    <input
                                        type="text"
                                        bind:value={method.shipping_push_supplier_username}
                                        class:input_empty_error={method.shipping_push_supplier_username === ''}
                                    />
                                </div>
                                <div class="input_con">
                                    <label>
                                        <i class="fa-solid fa-asterisk"></i> 
                                        {$_('settings.password')}
                                    </label>
                                    <input
                                        type="text"
                                        bind:value={method.shipping_push_supplier_password}
                                        class:input_empty_error={method.shipping_push_supplier_password === ''}

                                    />
                                </div>
                            </div>  

                            {:else if method.shipping_push_supplier==52}
                            <div class="input_box">
                                <div class="input_con">
                                    <label>
                                        <i class="fa-solid fa-asterisk"></i> 
                                        {$_('settings.username')}
                                    </label>
                                    <input
                                        type="text"
                                        bind:value={method.shipping_push_supplier_username1}
                                        class:input_empty_error={method.shipping_push_supplier_username1 === ''}
                                    />
                                </div>
                                <div class="input_con">
                                    <label>
                                        {$_('settings.username2')}
                                    </label>
                                    <input
                                        type="text"
                                        bind:value={method.shipping_push_supplier_username2}
                                    />
                                </div>
                                <div class="input_con">
                                    <label>
                                        {$_('settings.username3')}
                                    </label>
                                    <input
                                        type="text"
                                        bind:value={method.shipping_push_supplier_username3}
                                    />
                                </div>
                                <div class="input_con">
                                    <label>
                                        <i class="fa-solid fa-asterisk"></i> 
                                        {$_('settings.password')}
                                    </label>
                                    <input
                                        type="text"
                                        bind:value={method.shipping_push_supplier_password}
                                        class:input_empty_error={method.shipping_push_supplier_password === ''}

                                    />
                                </div>
                            </div>  
                            
                            {:else}
                            <div class="input_box">
                                <div class="input_con">
                                    <label>
                                        <i class="fa-solid fa-asterisk"></i> 
                                        {#if method.shipping_push_supplier==62} 
                                            {$_('settings.contract_number')}
                                        {:else if method.shipping_push_supplier==54}
                                            {$_('settings.username')}
                                        {:else}
                                            {$_('settings.customer_number')}
                                        {/if}
                                    </label>
                                    <input
                                        type="text"
                                        bind:value={method.shipping_push_supplier_code}
                                        on:input={(event) => method.shipping_push_supplier_code = validateAndSetSupplierCode(method.shipping_push_supplier, event.target.value)}
                                        class:input_empty_error={method.shipping_push_supplier_code === ''}
                                    />
                                </div>
                                {#if method.shipping_push_supplier==17} 
                                    <!-- {#if platforms[+method.shipping_push_supplier] && platforms[+method.shipping_push_supplier]?.pickup=="1"}
                                    <div class="input_con">
                                        <label>
                                            <i class="fa-solid fa-asterisk"></i> 
                                            {$_('settings.customer_number_pickup')}
                                            <p>{$_('settings.customer_number_pickup_notice')}</p>
                                        </label>
                                        <input
                                            type="text"
                                            bind:value={method.shipping_push_supplier_code_pickup}
                                            on:input={(event) => method.shipping_push_supplier_code_pickup = validateAndSetSupplierCode(method.shipping_push_supplier, event.target.value)}
                                            class:input_empty_error={method.shipping_push_supplier_code_pickup === ''}
                                        />
                                    </div>
                                    {/if} -->
                                {/if}

                                {#if method.shipping_push_supplier==54} 
                                    {#if platforms[+method.shipping_push_supplier] && platforms[+method.shipping_push_supplier]?.pickup=="1"}
                                    <div class="input_con">
                                        <label>
                                            <i class="fa-solid fa-asterisk"></i> 
                                            {$_('settings.password')}
                                        </label>
                                        <input
                                            type="text"
                                            bind:value={method.shipping_push_supplier_code_pickup}
                                            on:input={(event) => method.shipping_push_supplier_code_pickup = validateAndSetSupplierCode(method.shipping_push_supplier_code_pickup, event.target.value)}
                                            class:input_empty_error={method.shipping_push_supplier_code_pickup === ''}
                                        />
                                    </div>
                                    {/if}
                                {/if}
                                
                            </div>  
                            {/if}
                            {#if platforms[+method.shipping_push_supplier] && platforms[+method.shipping_push_supplier].token && platforms[+method.shipping_push_supplier].token=="1"}                     
                            <div class="input_box">
                                <div class="input_con">
                                    <label><i class="fa-solid fa-asterisk"></i> 
                                        {#if method.shipping_push_supplier==54} 
                                            {$_('settings.consignee')}                                    
                                        {:else}
                                            {$_('settings.token')}
                                        {/if}
                                    </label>
                                    <input type="text" bind:value={method.shipping_push_supplier_token} class:input_empty_error={method.shipping_push_supplier_token === ''}>
                                </div>
                            </div>  
                            {/if}
                            {#if platforms[+method.shipping_push_supplier] && platforms[+method.shipping_push_supplier].pickup && platforms[+method.shipping_push_supplier].pickup=="1"}
                            <div class="input_box">
                                <div class="input_con radio">
                                    <input id="pudo_enabled1_{method.shipping_push_supplier}" type="radio" name="pudo_enabled{method.shipping_push_supplier}" bind:group={method.enable_pickup} value="1">
                                    <label for="pudo_enabled1_{method.shipping_push_supplier}"><i class="fa-solid fa-asterisk"></i> {$_('settings.using_pudo')}</label>
                                </div>
                                <div class="input_con radio">
                                    <input id="pudo_enabled2_{method.shipping_push_supplier}" type="radio" name="pudo_enabled{method.shipping_push_supplier}" bind:group={method.enable_pickup}  value="0">
                                    <label for="pudo_enabled2_{method.shipping_push_supplier}"><i class="fa-solid fa-asterisk"></i> {$_('settings.not_using_pudo')}</label>
                                </div>
                            </div>
                            {/if}
                            {#if method.enable_pickup=="1"}
                                {#if shippingo == '2'}
                                <div class="py-3">
                                    <h3 class="text-[16px] font-bold">{$_('settings.wordpress_settings')}</h3>
                                </div>
                                <div class="py-2">{@html $_('settings.pudo_explanation_wordpress')}</div>
                                {:else}
                                <div>  
                                    <div class="input_box">                        
                                        <div class="input_con">
                                            <label>{$_('settings.pudo_static_text')}</label>
                                            <input type="text" bind:value={method.pickup_static_text}>
                                        </div>
                                        <div class="input_con">
                                            <label><i class="fa-solid fa-asterisk"></i> {$_('settings.pudo_price')}</label>
                                            <input type="text" bind:value={method.shipping_pickup_price}>
                                        </div>
                                        <div class="input_con">
                                            <label>{$_('settings.pudo_free_above')}</label>
                                            <input type="text" bind:value={method.shipping_free_pickup_above}>
                                        </div>                        
                                        <div class="input_con">
                                            <label>{$_('settings.limit_results')}</label>
                                            <input type="text" bind:value={method.limit_results}>
                                        </div>
                                    </div>  
                                    {#if shipping_pull_platform=="39" || shipping_pull_platform=="1"}
                                    <div class="input_box mt-5"> 
                                        <div class="input_con font-bold">
                                            {$_('settings.auto_pickup_desc')}
                                        </div>
                                    </div>

                                    <div class="input_box">    
                                        <div class="input_con">
                                            <label>
                                                <i class="fa-solid fa-asterisk"></i> {$_('settings.auto_pickup')}
                                                <ToolTip text={$_('companies.explain_auto_pickup')}></ToolTip>
                                            </label>
                                            <select bind:value={method.auto_pickup}>
                                                <option value="0">{$_('settings.no')}</option>
                                                <option value="1">{$_('settings.yes')}</option>                                
                                            </select>
                                        </div>
                                        <div class="input_con">
                                            <label>{$_('settings.auto_pickup_text')}</label>
                                            <input type="text" bind:value={method.auto_pickup_text}>
                                        </div>
                                    </div>
                                    
                                    {/if}
                                </div>
                                {/if} 

                                {#if shippingo == '2'}
                                <div class="input_box">    
                                    <div class="input_con">
                                        <label>
                                            <i class="fa-solid fa-asterisk"></i> {$_('settings.view_option')}
                                            <ToolTip text={$_('companies.explain_auto_pickup')}></ToolTip>
                                        </label>
                                        <select bind:value={method.view_option}>
                                            <option value="2">{$_('settings.list')}</option>
                                            <option value="1">{$_('settings.map')}</option>                                
                                        </select>
                                    </div>
                                    {#if method.view_option=="1"}
                                    <div class="input_con">
                                        <label>
                                            <i class="fa-solid fa-asterisk"></i>
                                            {$_('settings.google_key')}
                                        </label>
                                        <input type="text" bind:value={method.google_key} class:input_empty_error={method.google_key === '' || method.google_key==undefined}>
                                    </div>
                                    {:else}                                    
                                    <div class="input_con">
                                        <label>{$_('settings.datalogics_ncode_auto')}</label>
                                        <select bind:value={method.ncode_auto}>
                                            <option value="0">{$_('settings.no')}</option>
                                            <option value="1">{$_('settings.yes')}</option>                                
                                        </select>
                                    </div>
                                    <!-- <div class="input_con">
                                        <label>{$_('settings.cities_auto')}</label>
                                        <select bind:value={method.cities_auto}>
                                            <option value="0">{$_('settings.no')}</option>
                                            <option value="1">{$_('settings.yes')}</option>                                
                                        </select>
                                    </div>
                                    <div class="input_con">
                                        <label>{$_('settings.cities_auto_validation')}</label>
                                        <select bind:value={method.cities_auto_validation}>
                                            <option value="0">{$_('settings.no')}</option>
                                            <option value="1">{$_('settings.yes')}</option>                            
                                        </select>
                                    </div> -->
                                    {/if}
                                </div>
                                {/if}                                
                                
                            {/if} 
                        </div>
                        {/if}                         
                    {/each}
                </div> 
            </div> 
  
            <div class="shipment-flex-button fixed bottom-[20px] z-20 left-0 right-0 m-auto">
                <div class="create_button box-shadow" on:click={ handleSubmit }>{$_('settings.save')}</div>
            </div> 
        </div>
        
    </div>
</div>

